import { race, take, delay, call, select, put } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { ctaLabelSelectorProps } from '@grandvisionhq/configurator';
import { actions, statusLoading, statusUninit, statusSuccess } from '@grandvisionhq/state';
import { LensTypeStepContainer } from '../../../../steps/LensTypeStep/LensTypeStepContainer.js';
import { startPrescriptionGlassesConfiguration } from '../../../actions.js';
import { loadMissingPackages } from '../../../bundles/sagas.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getSelectedLensType, getFrameSku, getLensTypes } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';
import { fetchLensTypesSuccess, fetchLensTypesFailed } from '../../../bundles/actions.js';
import { selectLensType } from '../../../configurations/actions.js';

const lensTypeStepBase = {
    *onEnter () {
        /**
     * Blocks the onEnter for this step, until the action has passed that
     * prepares the RxGlasses state for this configuration.
     */ yield race([
            take(startPrescriptionGlassesConfiguration),
            delay(3000)
        ]);
        yield call(selectDefaultLensType);
    },
    *onNext () {
        const lensType = yield select(getSelectedLensType);
        if (!lensType) {
            return new Error(`Selecting a lens-type is required`);
        }
    },
    ctaLabel: createSelector(ctaLabelSelectorProps, getSelectedLensType, ({ defaultCtaLabel , alternativeCtaLabel  }, selectedLensType)=>{
        var ref;
        return Number(selectedLensType === null || selectedLensType === void 0 ? void 0 : (ref = selectedLensType.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 && alternativeCtaLabel ? {
            key: alternativeCtaLabel
        } : {
            key: defaultCtaLabel
        };
    }),
    view: LensTypeStepContainer
};
const isSuccess = actions.guard(fetchLensTypesSuccess);
const isFailed = actions.guard(fetchLensTypesFailed);
function* selectDefaultLensType() {
    const lensType = yield select(getSelectedLensType);
    const frameSku = yield select(getFrameSku);
    if (!frameSku) {
        console.warn(`Did not find a frame SKU for this configuration. Received: ${frameSku}`);
        return;
    }
    if (!lensType) {
        let lensTypes = yield select(getLensTypes);
        if (statusLoading(lensTypes) || statusUninit(lensTypes)) {
            // If it's still loading we're going to wait a bit for the loading to finish
            const [success] = yield race([
                take((a)=>isSuccess(a)
                ),
                take((a)=>isFailed(a) && a.payload.frameSku === frameSku
                ),
                delay(30000, true), 
            ]);
            if (success) {
                lensTypes = yield select(getLensTypes);
            }
        }
        if (statusSuccess(lensTypes)) {
            var ref;
            /**
       * Select the cheapest product that has the 'default' attribute set to true
       * If there's no default product, select the cheapest one
       */ let lensTypeSku = (ref = lensTypes.result[0]) === null || ref === void 0 ? void 0 : ref.sku;
            for (const product of lensTypes.result){
                if (product.isDefault) {
                    lensTypeSku = product.sku;
                    break;
                }
            }
            if (lensTypeSku) {
                yield put(selectLensType({
                    frameSku,
                    lensTypeSku,
                    reason: 'default selection'
                }));
            }
        }
    } else {
        // If no default lens-type is selected we make sure to kick-off the rest of the loading sequence by:
        yield call(loadMissingPackages, lensType.sku);
    }
}

export { lensTypeStepBase, selectDefaultLensType };
//# sourceMappingURL=lens-type.js.map
